import React from 'react';

import { ClearancesListPage } from '../../shared/clearances';
import { STAFF_CLEARANCE_LIST_QUERY_KEY } from './queryKeys';

export const StaffClearancesList: React.FC = () => {
  return (
    <ClearancesListPage
      title="Clearances"
      queryKeyBase={STAFF_CLEARANCE_LIST_QUERY_KEY}
      displayTypePrefKey="StaffClearances"
      showOrganization={true}
      showOrganizationFilter={true}
      queueCategory="StaffClearanceQueueNames"
    />
  );
};
